import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "../../components/IconButton";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { Button } from "../../components/ui/button";
import { useSelector } from "react-redux";

const StepTitle = ({ stepVal, drawerOpen=false, closeDrawer=() => {} }) => {
  let title;

  const location = useLocation();
  const navigate = useNavigate();
  const { extractionData } = useSelector((state) => state.Extractions);
  const { extVersion } = useSelector((state) => state.ExtVersions);

  const isViewRelatedRoute = location.pathname.includes('/extraction/view');
  const isViewFullDataRoute = location.pathname.includes('/extraction/view-full-data');
  const isOutputMappingsRoute = location.pathname.includes('/extraction/view/');

  switch (stepVal) {
    case 1:
      title = 'Project Details';
      break;
    case 2:
      title = 'Data Strategy';
      break;
    case 3:
      title = 'Columns Selection';
      break;
    case 4:
      title = isViewRelatedRoute ? `Extracted Sets \u00A0\u003E\u00A0 Version 1 \u00A0\u003E\u00A0 ${isOutputMappingsRoute ? 'Output Mappings' : 'View Data'}` : 'Data Preview';
      break;
    case 5:
      title = 'Multi-channel Campaign';
      break;
    default:
      title = 'Unknown Step';
  };


  const handleBack = () => {
    if(isViewFullDataRoute && extVersion?.key) navigate(`/extraction/view/${extVersion.key}`)
    else if(isViewRelatedRoute && extVersion?.key) navigate(`/extraction/${extractionData.key}`)
    else navigate(-1);
  };

  return (
    <>
    {
      drawerOpen && stepVal === 3 ? (
        <div className="flex items-center justify-between">
          <h2 className="text-white">Custom Column Details</h2>
          <IconButton
            variant="collapse"
            size="iconsm"
            Icon={XMarkIcon}
            onClick={closeDrawer}
            className={`transition-opacity duration-200 ${
              drawerOpen ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
          />
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <h2 className="text-white">{title}</h2>
          {isViewRelatedRoute && <Button 
              variant="default"
              size="sm"
              onClick={handleBack}
          >
            ← Back
          </Button>}
        </div>
      )
    }
    </>
  );
};

export default StepTitle;
